<template>
  <div>
    <div>
      <div class="record-card">
        <div class="card-item car-title">
          <div
            class="item-left"
            style="flex: 0 0 89px; color: #383838"
          >
            收支金额：
          </div>
          <div style="display: flex;justify-content: space-between; width: 100%;">
            <div
              class="item-right"
              style="margin-left: 4px"
            >
              ￥{{ record.redPacketAmount || 0 }}
            </div>

            <div
              class="item-amout"
              :style="{ color: getColor(record.distributeStatus) }"
            >
              {{ record.distributeStatusDesc }}
            </div>
          </div>
        </div>
        <div class="card-item">
          <div class="item-left">下单时间</div>
          <div class="item-right">
            {{ record.orderCreateTime || "" }}
          </div>
        </div>
        <div class="card-item">
          <div class="item-left">关联单号</div>
          <div class="item-right">
            {{ record.orderNo }}
          </div>
        </div>
        <div class="card-item">
          <div class="item-left">关联车牌号</div>
          <div class="item-right">
            {{ record.carNo || "无车牌" }}
          </div>
        </div>

        <div class="card-item">
          <div class="item-left">备注</div>
          <div class="item-right">
            {{ record.remark || "" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    record: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      redPacketDistributeStatus: [{ 'auditWait': '待审核' },
                                  { 'returned': '已退回' },
                                  { 'distributed': '已发放' },
                                  { 'withdrawn': '已提现' }]
    };
  },
  onLoad(options) {
    console.log('onLoad:', options);
  },
  onReady() {},
  methods: {
    getColor(type) {
      if (type === 'auditWait') {
        return '#5EC360';
      } else if (type === 'returned') {
        return '#F32222 ';
      }
      return '#999999';
    }
  }
};
</script>

<style lang="scss" scoped>
.record-card {
//   background: #ffffff;
//   border-radius: 8px;
//   padding: 16px 18px 16px 16px;
//   margin-bottom: 12px;

  .card-item {
    display: flex;
    align-items: center;
    font-size: 16px;

    .item-left {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #999999;
      letter-spacing: 0.48px;
      font-weight: 400;
      min-width: 82px;
    }

    .item-right {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #383838;
      letter-spacing: 0.48px;
      font-weight: 400;
      word-break: break-all;
      margin-left: 15px;
    }

    .item-amout {
      color: #999999;
    }

    & + .card-item {
      margin-top: 16px;
    }

    &.car-title {
      .item-left {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #383838;
      }

      .item-right {
        font-family: PingFangSC-Medium;
        color: #ff8a59;
        font-weight: 500;
      }
    }
  }
}

.blank-wrap {
  padding-top: 90px;
}
</style>
